(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-collection"]) return;
  try {
    
  if (!customElements.get('atelier-collection')) {
    customElements.define('atelier-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.bindPhotoControls();
        this.loadCatalog();
      }
      async loadCatalog() {
        const grid = this.querySelector('.atelier-catalog-grid');
        const controls = [...this.querySelectorAll('form input, form select, form button')];
        controls.forEach(control => control.disabled = true);
        this.setAttribute('aria-busy', 'true');
        const initial = [...grid.querySelectorAll('[data-card]')];
        const cards = Number(grid.dataset.currentPage) === 1 ? [...initial] : [];
        let next = Number(grid.dataset.currentPage) === 1 ? grid.dataset.nextPage : grid.dataset.firstPage;
        const visited = new Set();
        try {
          while (next) {
            const url = new URL(next, location.origin);
            if (url.origin !== location.origin || visited.has(url.href) || visited.size > 20) throw new Error('Invalid pagination');
            visited.add(url.href);
            const response = await fetch(url.href, {credentials: 'same-origin', signal: AbortSignal.timeout(12000)});
            if (!response.ok) throw new Error('Pagination unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const pageGrid = doc.querySelector('atelier-collection .atelier-catalog-grid');
            if (!pageGrid) throw new Error('Collection unavailable');
            cards.push(...pageGrid.querySelectorAll('[data-card]'));
            next = pageGrid.dataset.nextPage;
          }
          if (!this.isConnected) return;
          grid.replaceChildren(...cards);
          this.querySelector('[data-pagination]').hidden = true;
          controls.forEach(control => control.disabled = false);
        } catch {
          this.querySelector('[data-results]').textContent = initial.length + ' / ' + grid.dataset.total;
          this.querySelector('[data-filter-error]').hidden = false;
          return;
        } finally {
          this.setAttribute('aria-busy', 'false');
        }
        this.cards = Array.from(this.querySelectorAll('[data-card]')).map((el, index) => ({el, index, variants: JSON.parse(el.dataset.variants), size: Number(el.dataset.sizePosition), color: Number(el.dataset.colorPosition), colors: el.dataset.colors.split('|').filter(Boolean)}));
        for (const type of ['size', 'color']) {
          const values = new Set();
          for (const card of this.cards) {
            for (const v of card.variants) {
              const value = v['option' + card[type]];
              if (value && (type !== 'size' || this.dataset.largeCollection !== 'true' || this.isLargeSize(value))) { values.add(value); if (type === 'size' && value.includes('/')) value.split('/').forEach(part => values.add(part)); }
            }
            if (type === 'color') card.colors.forEach(c => values.add(c));
          }
          const field = this.querySelector(`[data-filter="${type}"]`);
          [...values].sort((a,b)=>{if(type!=='size')return a.localeCompare(b);const order=['XS','S','S/M','M','M/L','L','L/XL','XL','XXL','XXL/XXXL','XXXL','3XL','4XL','5XL','6XL','Plus Size','Queen Plus','Taille unique'];const x=order.indexOf(a),y=order.indexOf(b);return (x<0?999:x)-(y<0?999:y)||a.localeCompare(b)}).forEach(value => field.add(new Option(value, value)));
        }
        this.querySelector('form').addEventListener('submit', e => e.preventDefault());
        this.querySelector('form').addEventListener('input', () => this.filter());
        this.querySelector('form').addEventListener('reset', () => setTimeout(() => this.filter(), 0));
        this.restoreFilters();
        this.filter(false);
        this.onHistory = () => { this.restoreFilters(); this.filter(false); };
        window.addEventListener('popstate', this.onHistory);
      }
      disconnectedCallback() { window.removeEventListener('popstate', this.onHistory); }
      getCardPhotos(card, picked, focused) {
        const all = card.photoGallery || [];
        const sameOptions = picked && card.variants.every(v =>
          (!card.size || v['option' + card.size] === picked['option' + card.size]) &&
          (!card.color || v['option' + card.color] === picked['option' + card.color]));
        let photos = !focused || sameOptions ? all : all.filter(p => p.variantIds.some(id => String(id) === String(picked.id)));
        const source = focused ? card.media.get(String(picked.id)) : card.original.src;
        const normalize = src => { const url = new URL(src, location.origin); url.searchParams.delete('width'); url.searchParams.delete('height'); return url.pathname; };
        const primary = source && all.find(p => normalize(p.src) === normalize(source));
        if (source) photos = [primary || {src: source, alt: card.original.alt, key: source, variantIds: []}, ...photos];
        if (!photos.length) photos = [{src: card.original.src, alt: card.original.alt, key: card.original.src, variantIds: []}];
        const seen = new Set();
        return photos.filter(photo => {
          if (!photo.src) return false;
          const key = String(photo.key || normalize(photo.src));
          if (seen.has(key)) return false;
          seen.add(key); return true;
        });
      }
      updateCardPhotos(card, picked, focused) {
        const stage = card.el.querySelector('[data-card-photos]');
        if (!stage) return;
        card.photoGallery ??= JSON.parse(card.el.dataset.gallery || '[]');
        card.photos = this.getCardPhotos(card, picked, focused);
        card.photoIndex = 0;
        stage._card = card;
        card.el.querySelector('[data-card-photo-link]').setAttribute('href', card.el.querySelector('[data-card-link]').getAttribute('href'));
        const multiple = card.photos.length > 1;
        stage.querySelectorAll('[data-photo-step], [data-photo-count]').forEach(control => control.hidden = !multiple);
        this.showCardPhoto(card);
      }
      showCardPhoto(card) {
        const photo = card.photos[card.photoIndex];
        if (!photo) return;
        const image = card.el.querySelector('[data-card-image]');
        image.setAttribute('src', photo.src);
        image.setAttribute('alt', photo.alt || card.original.alt);
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        card.el.querySelector('[data-photo-count]').textContent = `${card.photoIndex + 1} / ${card.photos.length}`;
      }
      moveCardPhoto(card, direction) {
        if (!card || card.photos?.length < 2) return false;
        card.photoIndex = (card.photoIndex + direction + card.photos.length) % card.photos.length;
        this.showCardPhoto(card); return true;
      }
      bindPhotoControls() {
        if (this.photoControlsBound) return;
        this.photoControlsBound = true;
        this.addEventListener('click', event => {
          const stage = event.target.closest('[data-card-photos]');
          if (!stage) return;
          const control = event.target.closest('[data-photo-step]');
          if (control) {
            event.preventDefault(); event.stopPropagation();
            this.moveCardPhoto(stage._card, Number(control.dataset.photoStep));
          } else if (Date.now() < (stage._suppressPhotoClickUntil || 0)) {
            event.preventDefault(); event.stopPropagation();
          }
        });
        this.addEventListener('keydown', event => {
          const stage = event.target.closest('[data-card-photos]');
          if (!stage || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          if (this.moveCardPhoto(stage._card, event.key === 'ArrowRight' ? 1 : -1)) event.preventDefault();
        });
        this.addEventListener('dragstart', event => {
          if (event.target.closest('[data-card-photos]')) event.preventDefault();
        });
        this.addEventListener('pointerdown', event => {
          const stage = event.target.closest('[data-card-photos]');
          if (!stage || event.target.closest('[data-photo-step]') || event.button !== 0) return;
          this.photoPointer = {id: event.pointerId, stage, x: event.clientX, y: event.clientY};
        });
        this.addEventListener('pointercancel', () => { this.photoPointer = null; });
        this.addEventListener('pointerup', event => {
          const start = this.photoPointer; this.photoPointer = null;
          if (!start || start.id !== event.pointerId) return;
          const dx = event.clientX - start.x, dy = event.clientY - start.y;
          if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy) * 1.5) return;
          if (this.moveCardPhoto(start.stage._card, dx < 0 ? 1 : -1)) {
            start.stage._suppressPhotoClickUntil = Date.now() + 500;
            event.preventDefault();
          }
        });
      }
      isLargeSize(value) {
        return ['XXL', 'XXL/XXXL', 'XXXL', '3XL', '4XL', '5XL', '6XL', 'Plus Size', 'Queen Plus'].includes(value);
      }
      matchesSize(actual, wanted) {
        return actual === wanted || (!wanted.includes('/') && String(actual || '').split('/').includes(wanted));
      }
      normalizeSearch(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim(); }
      restoreFilters() {
        const params = new URL(location.href).searchParams;
        const mapping = {size:'taille',color:'couleur',sort:'tri',budget:'prix',query:'q'};
        for (const [key,param] of Object.entries(mapping)) this.querySelector(`[data-filter="${key}"]`).value = params.get(param) || '';
        this.querySelector('[data-filter="available"]').checked = params.get('disponible') === '1';
        const search = this.querySelector('[data-filter="query"]');
        const size = this.querySelector('[data-filter="size"]');
        const exact = [...size.options].find(o => o.value && this.normalizeSearch(o.value) === this.normalizeSearch(search.value));
        if (exact && !size.value) { size.value = exact.value; search.value = ''; }
      }
      syncFilterUrl() {
        const url = new URL(location.href);
        for (const [key,param] of Object.entries({size:'taille',color:'couleur',sort:'tri',budget:'prix',query:'q'})) {
          const value = this.querySelector(`[data-filter="${key}"]`).value;
          if (value) url.searchParams.set(param,value); else url.searchParams.delete(param);
        }
        if (this.querySelector('[data-filter="available"]').checked) url.searchParams.set('disponible','1'); else url.searchParams.delete('disponible');
        url.searchParams.delete('page');
        history.replaceState(history.state,'',url.pathname+url.search+url.hash);
      }
      matchesVariant(card, variant, criteria, ignoreAvailable = false) {
        const size = variant['option' + card.size];
        return (!criteria.size || this.matchesSize(size, criteria.size))
          && (criteria.size || this.dataset.largeCollection !== 'true' || this.isLargeSize(size))
          && (!criteria.color || (card.color ? variant['option' + card.color] === criteria.color : card.colors.includes(criteria.color)))
          && (ignoreAvailable || !criteria.available || variant.available)
          && (!criteria.budget || variant.price <= Number(criteria.budget) * 100);
      }
      filter(syncUrl = true) {
        const criteria = {
          size: this.querySelector('[data-filter="size"]').value,
          color: this.querySelector('[data-filter="color"]').value,
          available: this.querySelector('[data-filter="available"]').checked,
          budget: this.querySelector('[data-filter="budget"]')?.value
        };
        const sort = this.querySelector('[data-filter="sort"]').value;
        const terms = this.normalizeSearch(this.querySelector('[data-filter="query"]').value).split(/\s+/).filter(Boolean);
        if (syncUrl) this.syncFilterUrl();
        const focused = Boolean(criteria.size || criteria.color || criteria.available || criteria.budget || this.dataset.largeCollection === 'true');
        const money = cents => new Intl.NumberFormat(this.dataset.locale || 'fr-FR', {style: 'currency', currency: this.dataset.currency || 'EUR'}).format(cents / 100);
        const groups = this.cards.map(card => ({card, variants: terms.every(term => this.normalizeSearch(card.el.dataset.search).includes(term)) ? card.variants.filter(v => this.matchesVariant(card, v, criteria)) : []}));
        const minimum = group => { const available = group.variants.filter(v => v.available); const shown = focused && available.length ? available : group.variants; return shown.length ? Math.min(...shown.map(v => v.price)) : Infinity; };
        groups.sort((a, b) => sort ? (minimum(a) - minimum(b)) * (sort === 'asc' ? 1 : -1) || a.card.index - b.card.index : a.card.index - b.card.index);
        let count = 0;
        for (const {card, variants} of groups) {
          card.el.hidden = variants.length === 0;
          this.querySelector('.atelier-catalog-grid').append(card.el);
          if (!variants.length) continue;
          count++;
          const link = card.el.querySelector('[data-card-link]');
          const img = card.el.querySelector('[data-card-image]');
          const price = card.el.querySelector('[data-card-price]');
          const selection = card.el.querySelector('[data-card-selection]');
          if (!card.original) {
            card.original = {href: link.getAttribute('href'), price: price.innerHTML, src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes'), alt: img.getAttribute('alt')};
            card.media = new Map(JSON.parse(card.el.dataset.variantImages).map(image => [String(image.id), image.src]));
          }
          const choices = [...variants].sort((a, b) => Number(b.available) - Number(a.available) || a.price - b.price);
          const picked = choices[0];
          const variantUrl = variant => {
            const url = new URL(card.original.href, location.origin);
            url.searchParams.set('variant', String(variant.id));
            return url.pathname + url.search;
          };
          if (focused) {
            link.setAttribute('href', variantUrl(picked));
            price.textContent = money(picked.price);
            const size = picked['option' + card.size];
            const color = picked['option' + card.color];
            selection.textContent = [size, color, picked.available ? this.dataset.availableLabel : this.dataset.unavailableLabel].filter(Boolean).join(' · ');
            selection.hidden = false;
            const source = card.media.get(String(picked.id));
            img.setAttribute('src', source || card.original.src);
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.setAttribute('alt', source ? [card.original.alt, size, color].filter(Boolean).join(' — ') : card.original.alt);
          } else {
            link.setAttribute('href', card.original.href);
            price.innerHTML = card.original.price;
            for (const name of ['src', 'srcset', 'sizes', 'alt']) {
              if (card.original[name] === null) img.removeAttribute(name);
              else img.setAttribute(name, card.original[name]);
            }
            selection.hidden = true;
            selection.textContent = '';
          }
          this.updateCardPhotos(card, picked, focused);
          card.el.querySelectorAll('[data-size-choice]').forEach(chip => {
            const chipSize = chip.dataset.sizeChoice;
            const matching = card.variants.filter(v => v['option' + card.size] === chipSize && this.matchesVariant(card, v, {...criteria, size: chipSize}, true));
            const available = matching.find(v => v.available);
            const variant = available || matching[0];
            chip.hidden = !variant || Boolean(criteria.size && !this.matchesSize(chipSize, criteria.size)) || (this.dataset.largeCollection === 'true' && !this.isLargeSize(chipSize)) || Boolean(criteria.available && !available);
            chip.classList.toggle('atelier-size-out', !available);
            chip.classList.toggle('atelier-size-selected', focused && chipSize === picked['option' + card.size]);
            if (variant) chip.setAttribute('href', variantUrl(variant));
            chip.setAttribute('aria-label', chipSize + ' — ' + (available ? this.dataset.availableLabel : this.dataset.unavailableLabel));
          });
        }
        this.querySelector('[data-results]').textContent = String(count);
        this.querySelector('[data-empty]').hidden = count !== 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-editorial')) {
  class AtelierEditorial extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.wide = window.matchMedia('(min-width: 1000px) and (min-height: 760px) and (hover: hover) and (pointer: fine)');
      this.pin = this.querySelector('[data-pin]');
      this.stage = this.querySelector('[data-stage]');
      this.viewport = this.querySelector('[data-viewport]');
      this.rail = this.querySelector('[data-rail]');
      this.bar = this.querySelector('[data-progress]');
      this.bands = [...this.querySelectorAll('[data-tone]')];
      this.drifters = [...this.querySelectorAll('[data-drift]')];
      this.buttons = [...this.querySelectorAll('[data-step]')];
      this.animations = new Set();
      this.wrapper = this.closest('.page-wrapper');
      if (!this.pin || !this.stage || !this.viewport || !this.rail) return;
      const signal = this.abort.signal;
      const passive = {passive:true, signal};
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.paint(); });
      };
      this.resize = () => {
        if (this.measureFrame) return;
        this.measureFrame = requestAnimationFrame(() => { this.measureFrame = 0; this.measure(); this.paint(); });
      };
      window.addEventListener('scroll', this.schedule, passive);
      this.wrapper?.addEventListener('scroll', this.schedule, passive);
      window.addEventListener('resize', this.resize, passive);
      window.addEventListener('pageshow', this.resize, {signal});
      this.viewport.addEventListener('scroll', this.schedule, passive);
      this.addEventListener('pointerdown', () => {this.targetPosition = null;}, passive);
      window.addEventListener('wheel', () => {this.targetPosition = null;}, passive);
      this.reduce.addEventListener('change', this.resize, {signal});
      this.wide.addEventListener('change', this.resize, {signal});
      this.buttons.forEach(button => button.addEventListener('click', () => this.step(Number(button.dataset.step)), {signal}));
      this.viewport.addEventListener('keydown', event => {
        if (event.target !== this.viewport || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.seek(event.key === 'Home' ? 0 : this.distance, true);
        else this.step(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal});
      this.viewport.addEventListener('focusin', event => {
        const card = event.target.closest('.ae-look');
        if (!this.pinned || !card) return;
        const left = card.getBoundingClientRect().left - this.rail.getBoundingClientRect().left;
        if (left < this.position || left + card.offsetWidth > this.position + this.viewport.clientWidth) this.seek(left, false);
      }, {signal});
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.resize);
        this.observer.observe(this.viewport);
        this.observer.observe(this.rail);
      }
      this.querySelectorAll('img').forEach(img => {
        if (!img.complete) img.addEventListener('load', this.resize, {once:true, signal});
      });
      if ('IntersectionObserver' in window) {
        this.reveals = new IntersectionObserver(entries => {
          let stagger = 0;
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const alreadyAbove = entry.boundingClientRect.bottom < window.innerHeight * .18;
            if (this.motion() && !alreadyAbove && entry.target.animate) {
              const animation = entry.target.animate(
                [{transform:'translateY(16px)'},{transform:'translateY(0)'}],
                {duration:520, delay:Math.min(stagger++ * 65,195), easing:'cubic-bezier(.22,1,.36,1)'}
              );
              this.animations.add(animation);
              animation.finished.then(() => this.animations.delete(animation), () => this.animations.delete(animation));
            }
            this.reveals.unobserve(entry.target);
          }
        }, {threshold:.08, rootMargin:'0px 0px -5% 0px'});
        this.querySelectorAll('.ae-reveal').forEach(el => this.reveals.observe(el));
        this.films = new IntersectionObserver(entries => entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting && this.motion() && !document.hidden) video.play()?.catch(() => {});
          else video.pause();
        }), {threshold:.5});
        this.querySelectorAll('video').forEach(video => this.films.observe(video));
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, {signal});
      this.measure();
      this.classList.add('ae-ready');
      this.paint();
    }
    motion() { return this.dataset.motion !== 'false' && !this.reduce.matches; }
    clamp(value, min=0, max=1) { return Math.max(min, Math.min(max, value)); }
    view() {
      const root = this.wrapper && /auto|scroll/.test(window.getComputedStyle(this.wrapper).overflowY) ? this.wrapper : window;
      return root === window
        ? {root, top:0, height:window.innerHeight, scroll:window.scrollY}
        : {root, top:root.getBoundingClientRect().top, height:root.clientHeight, scroll:root.scrollTop};
    }
    measure() {
      const view = this.view();
      const wasPinned = Boolean(this.pinned);
      this.distance = Math.max(0, this.rail.scrollWidth - this.viewport.clientWidth);
      this.inset = 16;
      this.pinned = this.motion() && this.wide.matches && this.distance > 1 && this.stage.offsetHeight + this.inset * 2 <= view.height;
      this.travel = this.pinned ? Math.min(this.distance, Math.max(480, view.height * 1.4)) : 0;
      this.pin.classList.toggle('ae-pinned', this.pinned);
      const height = this.pinned ? `${this.stage.offsetHeight + this.travel}px` : '';
      if (this.pin.style.height !== height) this.pin.style.height = height;
      if (this.pinned && !wasPinned) this.viewport.scrollLeft = 0;
      if (!this.pinned) {
        this.rail.style.transform = '';
        if (wasPinned) this.viewport.scrollLeft = this.clamp(this.position || 0, 0, this.distance);
      }
      if (!this.motion()) {
        this.resetPalette();
        this.animations.forEach(animation => animation.cancel());
        this.drifters.forEach(el => el.style.removeProperty('--ae-shift'));
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    }
    paint() {
      const view = this.view();
      this.position = this.pinned
        ? this.clamp((view.top + this.inset - this.pin.getBoundingClientRect().top) / this.travel) * this.distance
        : this.clamp(this.viewport.scrollLeft, 0, this.distance);
      if (this.pinned) this.rail.style.transform = `translate3d(${-this.position}px,0,0)`;
      if (this.targetPosition != null && Math.abs(this.targetPosition - this.position) < 2) this.targetPosition = null;
      const progress = this.distance ? this.position / this.distance : 1;
      if (this.bar) this.bar.style.transform = `scaleX(${progress})`;
      this.buttons.forEach(button => {button.disabled = Number(button.dataset.step) < 0 ? this.position <= 1 : this.position >= this.distance - 1;});
      if (!this.motion()) return;
      for (const el of this.drifters) {
        const rect = el.getBoundingClientRect();
        if (rect.bottom < view.top || rect.top > view.top + view.height) continue;
        const shift = this.clamp((view.top + view.height * .5 - rect.top - rect.height * .5) * Number(el.dataset.drift), -12, 12);
        el.style.setProperty('--ae-shift', `${shift.toFixed(2)}px`);
      }
      this.updatePalette(view);
    }
    paletteTone(view) {
      if (!this.bands.length) return 'light';
      const line = view.top + view.height * .42;
      const tops = this.bands.map(band => band.getBoundingClientRect().top);
      let index = 0;
      for (let i = 1; i < tops.length; i++) if (tops[i] <= line) index = i;
      const previous = this.paletteBand;
      if (previous != null && previous < tops.length) {
        if (index > previous && tops[index] > line - 16) index = previous;
        if (index < previous && tops[previous] < line + 16) index = previous;
      }
      this.paletteBand = index;
      return this.bands[index].dataset.tone;
    }
    paletteContrast(a, b) {
      const luminance = rgb => rgb.reduce((sum, channel, i) => {
        const n = channel / 255;
        return sum + (n <= .04045 ? n / 12.92 : ((n + .055) / 1.055) ** 2.4) * [.2126,.7152,.0722][i];
      }, 0);
      const x = luminance(a), y = luminance(b);
      return (Math.max(x, y) + .05) / (Math.min(x, y) + .05);
    }
    paletteInk(paper) {
      const choices = [[48,29,37], [255,245,233]];
      choices.sort((a,b) => this.paletteContrast(paper,b) - this.paletteContrast(paper,a));
      if (this.paletteContrast(paper,choices[0]) >= 4.5) return choices[0];
      return this.paletteContrast(paper,[0,0,0]) >= this.paletteContrast(paper,[255,255,255]) ? [0,0,0] : [255,255,255];
    }
    applyPalette(rgb) {
      this.paletteRGB = rgb.map(Math.round);
      const ink = this.paletteInk(this.paletteRGB);
      const edge = this.paletteRGB.map((n,i) => Math.round(n * .15 + ink[i] * .85));
      for (const [name, value] of [['paper',this.paletteRGB],['ink',ink],['edge',edge]]) {
        this.style.setProperty(`--ae-flow-${name}`, `rgb(${value.join(',')})`);
      }
      this.classList.add('ae-flow');
    }
    resetPalette() {
      if (this.paletteFrame) cancelAnimationFrame(this.paletteFrame);
      this.paletteFrame = 0;
      this.paletteRGB = null;
      this.paletteTarget = null;
      this.paletteBand = null;
      this.classList.remove('ae-flow');
      for (const name of ['paper','ink','edge']) this.style.removeProperty(`--ae-flow-${name}`);
    }
    updatePalette(view) {
      const colors = {light:[255,255,255], ink:[40,19,30], cream:[241,236,227]};
      const tone = this.paletteTone(view);
      if (tone === this.paletteTarget) return;
      const target = colors[tone] || colors.light;
      this.paletteTarget = tone;
      if (this.paletteFrame) cancelAnimationFrame(this.paletteFrame);
      this.paletteFrame = 0;
      if (!this.paletteRGB) {
        this.applyPalette(target);
        return;
      }
      const start = [...this.paletteRGB];
      const started = performance.now();
      const tick = now => {
        this.paletteFrame = 0;
        if (!this.motion() || !this.isConnected) {
          this.resetPalette();
          return;
        }
        const t = this.clamp((now - started) / 600);
        const eased = t * t * (3 - 2 * t);
        this.applyPalette(start.map((value,i) => value + (target[i] - value) * eased));
        if (t < 1) this.paletteFrame = requestAnimationFrame(tick);
      };
      this.paletteFrame = requestAnimationFrame(tick);
    }

    step(direction) {
      const origin = this.rail.getBoundingClientRect().left;
      const stops = [...this.rail.querySelectorAll('.ae-look')].map(card => this.clamp(card.getBoundingClientRect().left - origin, 0, this.distance));
      const current = this.targetPosition ?? this.position ?? 0;
      const target = direction > 0 ? stops.find(stop => stop > current + 2) ?? this.distance : stops.reverse().find(stop => stop < current - 2) ?? 0;
      this.seek(target, true);
    }
    seek(position, smooth) {
      const desired = this.clamp(position, 0, this.distance);
      this.targetPosition = desired;
      const behavior = smooth && this.motion() ? 'smooth' : 'instant';
      if (this.pinned) {
        const view = this.view();
        view.root.scrollTo({top:view.scroll + this.pin.getBoundingClientRect().top - view.top - this.inset + desired / this.distance * this.travel, behavior});
      }
      else this.viewport.scrollTo({left:desired, behavior});
    }
    disconnectedCallback() {
      this.resetPalette();
      this.abort?.abort();
      this.observer?.disconnect();
      this.reveals?.disconnect();
      this.films?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      if (this.frame) cancelAnimationFrame(this.frame);
      if (this.measureFrame) cancelAnimationFrame(this.measureFrame);
      this.frame = 0; this.measureFrame = 0;
    }
  }
  customElements.define('atelier-editorial', AtelierEditorial);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-cart-count')) {
  class AtelierCartCount extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.revision = 0;
      const signal = this.abort.signal;
      this.output = this.querySelector('[data-cart-count]');
      if (!this.output) return;
      import('@shopify/events').then(({StandardEvents}) => {
        if (signal.aborted) return;
        document.addEventListener(StandardEvents.cartLinesUpdate, event => this.onCart(event), {signal});
        this.refresh();
      }).catch(() => {});
      window.addEventListener('pageshow', event => {if (event.persisted) this.refresh();}, {signal});
      document.addEventListener('visibilitychange', () => {if (!document.hidden) this.refresh();}, {signal});
    }
    setCount(value) {
      if (typeof value !== 'number' || !Number.isSafeInteger(value) || value < 0) return;
      const text = String(value);
      if (this.output.textContent !== text) this.output.textContent = text;
    }
    async onCart(event) {
      const revision = ++this.revision;
      if (!event.promise) {this.refresh();return;}
      try {
        const result = await event.promise;
        if (this.abort.signal.aborted || revision !== this.revision) return;
        if (typeof result?.cart?.totalQuantity === 'number') this.setCount(result.cart.totalQuantity);
        else this.refresh();
      } catch {
        if (!this.abort.signal.aborted && revision === this.revision) this.refresh();
      }
    }
    async refresh() {
      const revision = ++this.revision;
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      const timer = setTimeout(() => request.abort(), 8000);
      try {
        const url = new URL(this.dataset.cartUrl, window.location.origin);
        if (url.origin !== window.location.origin) return;
        const response = await fetch(url.href, {credentials:'same-origin',cache:'no-store',signal:request.signal});
        if (!response.ok) return;
        const cart = await response.json();
        if (!this.abort.signal.aborted && revision === this.revision) this.setCount(cart.item_count);
      } catch {} finally {clearTimeout(timer);}
    }
    disconnectedCallback() {this.abort?.abort();this.request?.abort();}
  }
  customElements.define('atelier-cart-count', AtelierCartCount);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-size-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-size-recommendations')) {
  customElements.define('atelier-size-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.onChange = event => {
        const picker = event.target.closest('variant-picker');
        if (!picker || String(picker.dataset.productId) !== this.dataset.productId) return;
        const option = event.target instanceof HTMLSelectElement ? event.target.selectedOptions[0] : event.target;
        if (option?.dataset.optionName === 'Taille') this.showSize(option.value);
      };
      document.addEventListener('change', this.onChange);
      this.showSize(this.dataset.initialSize);
    }
    disconnectedCallback() { document.removeEventListener('change', this.onChange); this.started = false; }
    matchesSize(actual, wanted) {
      return Boolean(wanted) && (actual === wanted || (!wanted.includes('/') && actual.split('/').includes(wanted)));
    }
    showSize(size) {
      this.querySelector('[data-chosen-size]').textContent = size || '';
      let count = 0;
      for (const card of this.querySelectorAll('[data-related]')) {
        const variants = JSON.parse(card.dataset.variants);
        const picked = variants.find(v => v.available && v.size === size) || variants.find(v => v.available && this.matchesSize(v.size, size));
        card.hidden = !picked || count >= 4;
        if (card.hidden) continue;
        count++;
        card.querySelector('a').href = picked.url;
        card.querySelector('img').src = picked.image;
        card.querySelector('img').removeAttribute('srcset');
        card.querySelector('[data-related-size]').textContent = picked.size;
        card.querySelector('[data-related-price]').textContent = new Intl.NumberFormat(this.dataset.locale || 'fr-FR', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(picked.price / 100);
      }
      const more = this.querySelector('[data-related-more]');
      const url = new URL(more.getAttribute('href'), location.origin);
      if (size) url.searchParams.set('taille', size); else url.searchParams.delete('taille');
      more.href = url.pathname + url.search;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-product"]) return;
  try {
    
if(!customElements.get('gp-product')){
 customElements.define('gp-product',class extends HTMLElement{
  connectedCallback(){
   if(this._ready)return;this._ready=true;
   const q=s=>this.querySelector(s);
   this.variants=JSON.parse(q('[data-variants]').textContent);
   this.form=q('[data-form]');this.idInput=q('[data-variant-id]');this.add=q('[data-add]');this.msg=q('[data-msg]');this.stock=q('[data-stock]');
   this.opts=[...this.querySelectorAll('[data-option]')];
   this.sizeIdx=this.opts.findIndex(f=>f.hasAttribute('data-size'));
   this.colIdx=this.opts.length===2&&this.sizeIdx>-1?1-this.sizeIdx:-1;
   this.root=window.Shopify?.routes?.root||'/';
   this.reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
   this.fmt=new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:window.Shopify?.currency?.active||'EUR'});
   this.form.addEventListener('change',e=>{const f=e.target.closest('[data-option]');this.onChange(false,f?+f.dataset.option:-1)});
   this.form.addEventListener('submit',e=>this.submit(e));
   this.stock.addEventListener('click',e=>{const b=e.target.closest('[data-pick]');if(!b)return;const idx=+b.dataset.pick,f=this.opts[idx];const i=f&&[...f.querySelectorAll('input')].find(x=>x.value===b.dataset.val);if(!i)return;i.checked=true;this.onChange(false,idx);i.focus({preventScroll:true})});
   this.sticky=q('[data-sticky]');this.sa=q('[data-sticky-add]');this.sc=q('[data-sticky-cart]');this.ssel=q('[data-sticky-sel]');
   this.sa.addEventListener('click',()=>this.stickyAdd());
   document.body.classList.add('gp-pdp-pad');
   this.io=new IntersectionObserver(([e])=>{const on=!e.isIntersecting&&e.boundingClientRect.top<0;this.sticky.classList.toggle('is-on',on);this.sticky.setAttribute('aria-hidden',String(!on));[this.sa,this.sc].forEach(b=>b.tabIndex=on?0:-1)});
   this.io.observe(this.add);
   this.g=q('[data-gallery]');this.cnt=q('[data-counter]');this.figs=[...this.g.querySelectorAll('figure[data-media-id]')];
   if(this.cnt)this.g.addEventListener('scroll',()=>this.count(),{passive:true});
   this.mediaId=null;
   this.onChange(true,-1);
  }
  disconnectedCallback(){this.io?.disconnect();document.body.classList.remove('gp-pdp-pad')}
  selected(){return this.opts.map(f=>f.querySelector('input:checked')?.value)}
  count(){const w=this.g.clientWidth||1,n=this.figs.length;this.cnt.textContent=`${Math.min(n,Math.round(this.g.scrollLeft/w)+1)} / ${n}`}
  onChange(initial,changed){
   const sel=this.selected(),S=this.sizeIdx,avail=this.variants.filter(v=>v.available);
   const fits=(v,skip)=>v.options.every((o,j)=>skip.includes(j)||sel[j]===undefined||o===sel[j]);
   this.opts.forEach((f,idx)=>{
    const isSize=idx===S,s=f.querySelector('[data-selected]');
    s.textContent=sel[idx]||'à choisir';s.classList.toggle('is-empty',!sel[idx]);
    f.querySelectorAll('label').forEach(l=>{
     const val=l.querySelector('input').value;
     /* Taille : barrée seulement si elle est épuisée dans le coloris choisi. Coloris : barré seulement s'il est épuisé dans toutes les tailles. */
     const ok=avail.some(v=>v.options[idx]===val&&fits(v,isSize?[idx]:[idx,S]));
     l.classList.toggle('is-out',!ok);
     let t='';
     if(!ok){
      if(isSize){const where=sel.filter((x,j)=>j!==idx&&x).join(' / ');t=where&&avail.some(v=>v.options[idx]===val)?` – épuisée en ${where}`:' – épuisée'}
      else t=' – épuisé';
     }
     l.querySelector('[data-out]').textContent=t;
    });
   });
   const missing=this.opts.findIndex((f,i)=>sel[i]===undefined);
   const cand=this.variants.filter(v=>fits(v,[]));
   const v=!this.opts.length?this.variants[0]:(missing<0?this.variants.find(x=>x.options.every((o,j)=>o===sel[j])):null);
   const shown=v||cand.find(x=>x.available)||cand[0];
   if(shown){
    this.querySelectorAll('.gp-pdp__price [data-price], .gp-pdp__sticky [data-price]').forEach(p=>p.textContent=this.fmt.format(shown.price/100));
    const cmp=this.querySelector('[data-compare]');cmp.hidden=!(shown.compare_at_price>shown.price);if(!cmp.hidden)cmp.textContent=this.fmt.format(shown.compare_at_price/100);
   }
   let label,sLabel;
   this.stock.textContent='';
   if(missing>-1){
    this.idInput.value='';this.add.disabled=true;
    label=missing===S?'Choisissez votre taille':'Choisissez une option';sLabel=missing===S?'Choisir la taille':'Choisir';
   }else if(!v){
    this.idInput.value='';this.add.disabled=true;label='Indisponible dans cette combinaison';sLabel='Indisponible';
   }else{
    this.idInput.value=v.id;this.add.disabled=!v.available;label=v.available?'Ajouter au panier':'Épuisé';sLabel=v.available?'Ajouter':'Épuisé';
    this.stockMsg(v,sel,avail);
   }
   if(this.busy)this.add.disabled=true;else{this.add.textContent=label;this.sa.textContent=sLabel}
   if(!this.flashing)this.ssel.textContent=missing>-1&&missing===S?'Taille à choisir':sel.filter(Boolean).join(' · ');
   /* Galerie : photo du coloris (variant.featured_media). La photo change uniquement si la variante possède une autre image. */
   const mv=v&&v.featured_media?v:(cand.find(x=>x.available&&x.featured_media)||cand.find(x=>x.featured_media));
   const mid=mv?String(mv.featured_media.id):null;
   if(mid&&mid!==this.mediaId)this.showMedia(mid,!initial);
   if(!initial&&v){const u=new URL(location);u.searchParams.set('variant',v.id);history.replaceState(history.state,'',u)}
  }
  stockMsg(v,sel,avail){
   const p=this.stock,S=this.sizeIdx,C=this.colIdx;
   if(v.available){p.textContent='En stock';return}
   if(S<0)return;
   if(C<0){p.textContent='Cette taille est épuisée.';return}
   const alts=[...new Set(avail.filter(x=>x.options[S]===sel[S]).map(x=>x.options[C]))];
   p.append(`La taille ${sel[S]} est épuisée en ${sel[C]}.`);
   if(!alts.length)return;
   p.append(' Disponible en ');
   alts.forEach((a,i)=>{if(i)p.append(', ');const b=document.createElement('button');b.type='button';b.className='gp-pdp__alt';b.dataset.pick=C;b.dataset.val=a;b.textContent=a;b.setAttribute('aria-label',`Choisir ${a}`);p.append(b)});
   p.append('.');
  }
  showMedia(id,animate){
   const f=this.figs.find(x=>x.dataset.mediaId===id);if(!f)return;
   this.mediaId=id;
   this.figs.forEach(x=>x.classList.toggle('is-hero',x===f));
   const g=this.g,behavior=animate&&!this.reduce?'smooth':'auto';
   if(g.scrollWidth>g.clientWidth+2){g.scrollTo({left:f.offsetLeft,behavior});if(!animate&&this.cnt)this.count()}
   else if(animate){const r=f.getBoundingClientRect();if(r.bottom<innerHeight*.35)window.scrollTo({top:scrollY+r.top-110,behavior})}
  }
  stickyAdd(){
   const sel=this.selected(),missing=this.opts.findIndex((f,i)=>sel[i]===undefined);
   if(missing>-1)return this.ask(this.opts[missing]);
   if(this.add.disabled)return this.ask(this.opts[this.sizeIdx]||this.opts[0]);
   this.fromSticky=true;this.form.requestSubmit();
  }
  ask(f){
   if(!f){this.add.scrollIntoView({behavior:this.reduce?'auto':'smooth',block:'center'});return}
   f.scrollIntoView({behavior:this.reduce?'auto':'smooth',block:'center'});
   const ins=[...f.querySelectorAll('input')];
   const i=ins.find(x=>x.checked)||ins.find(x=>!x.closest('label').classList.contains('is-out'))||ins[0];
   if(i)i.focus({preventScroll:true});
   f.classList.remove('is-ask');void f.offsetWidth;f.classList.add('is-ask');
   clearTimeout(this.askT);this.askT=setTimeout(()=>f.classList.remove('is-ask'),2400);
  }
  flash(ok,text){
   const s=this.sticky,hadFocus=document.activeElement===this.sa;
   clearTimeout(this.flT);this.flashing=true;
   s.classList.toggle('is-done',ok);s.classList.toggle('is-err',!ok);this.ssel.textContent=text;
   if(ok){this.sa.hidden=true;this.sc.hidden=false;if(hadFocus)this.sc.focus()}
   this.flT=setTimeout(()=>{const f=document.activeElement===this.sc;s.classList.remove('is-done','is-err');this.sc.hidden=true;this.sa.hidden=false;this.flashing=false;this.onChange(true,-1);if(f)this.sa.focus()},ok?5000:4000);
  }
  async submit(e){
   e.preventDefault();
   const fromSticky=this.fromSticky;this.fromSticky=false;
   if(this.busy)return;
   if(this.add.disabled||!this.idInput.value){if(fromSticky)this.stickyAdd();return}
   this.busy=true;this.msg.textContent='';
   this.add.disabled=true;this.sa.disabled=true;this.add.textContent='Ajout…';if(fromSticky)this.sa.textContent='Ajout…';
   try{
    const r=await fetch(this.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+this.idInput.value,quantity:1}]})});
    const data=await r.json().catch(()=>({}));
    if(!r.ok){const d=String(data.description||data.message||'');throw new Error(r.status===422?(/épuis|sold out/i.test(d)?'Cet article vient d’être épuisé.':'Quantité maximale disponible déjà dans votre panier.'):'Impossible d’ajouter cet article. Réessayez.')}
    try{const cart=await (await fetch(this.root+'cart.js',{headers:{Accept:'application/json'}})).json();document.querySelectorAll('.gp-cart').forEach(a=>{let b=a.querySelector('b');if(!b){b=document.createElement('b');a.appendChild(b)}b.textContent=cart.item_count})}catch(_){}
    this.msg.innerHTML='Ajouté au panier <span aria-hidden="true">✓</span> · <a href="'+this.root+'cart">Voir le panier</a>';
    if(fromSticky)this.flash(true,'Ajouté au panier ✓');
   }catch(err){this.msg.textContent=err.message||'Impossible d’ajouter cet article.';if(fromSticky)this.flash(false,this.msg.textContent)}
   finally{this.busy=false;this.sa.disabled=false;this.onChange(true,-1)}
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-retractation"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gp-retract')){
 customElements.define('gp-retract',class extends HTMLElement{
  connectedCallback(){
   if(this._ready)return;this._ready=true;
   const form=this.querySelector('#GpRetractForm');if(!form)return;if(/[?&]contact_posted=true/.test(location.search)&&!this.querySelector('.gp-retract__ok')){const ok=document.createElement('div');ok.className='gp-retract__ok';ok.setAttribute('role','status');ok.innerHTML='<p><strong>Votre déclaration de rétractation a bien été envoyée.</strong></p><p>Nous vous adressons un accusé de réception par e-mail à l’adresse indiquée.</p>';form.before(ok);form.hidden=true;}
   const open=this.querySelector('[data-retract-open]'),fields=this.querySelector('[data-retract-fields]'),time=this.querySelector('[data-retract-time]');
   if(open&&fields){
    const set=on=>{fields.hidden=!on;open.setAttribute('aria-expanded',String(on));open.hidden=on};
    const fromLink=()=>location.hash==='#renoncer';
    const hasErr=!!this.querySelector('.gp-retract__err');
    set(fromLink()||hasErr);
    open.addEventListener('click',()=>{set(true);this.querySelector('#GpRetractName')?.focus()});
    addEventListener('hashchange',()=>{if(fromLink()){set(true);this.scrollIntoView({block:'start'})}});
    if(fromLink())setTimeout(()=>{this.scrollIntoView({block:'start'});this.querySelector('#GpRetractName')?.focus({preventScroll:true})},150);
   }
   form.addEventListener('submit',()=>{
    if(!time)return;
    const d=new Date();
    time.value=d.toLocaleString('fr-FR',{timeZone:'Europe/Paris',dateStyle:'full',timeStyle:'medium'})+' (heure de Paris)';
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
